import { CountryCode } from "@freightsimple/generated-dashboard-openapi-client/models/CountryCode";

interface FlagProps {
  countryCode: CountryCode | undefined;
}

export function LocationsFlag(props: FlagProps) {
  const { countryCode } = props;

  if (countryCode === undefined) {
    return <></>;
  }

  if (countryCode === CountryCode.Canada) {
    return (
      <img
        alt="Canada"
        style={{
          marginLeft: "5px",
          position: "relative",
          top: "-2px",
        }}
        width="24"
        height="15"
        src="/canadaFlag.png"
      />
    );
  }

  if (countryCode === CountryCode.UnitedStates) {
    return (
      <img
        alt="United States"
        style={{
          marginLeft: "5px",
          position: "relative",
          top: "-2px",
        }}
        width="24"
        height="15"
        src="/usFlag.png"
      />
    );
  }

  throw new Error("Not supported yet");
}
